import { NamedStyle, GenericStyleProp } from "@design-system/style-sheet"

export * from "@design-system/style-sheet"

export type StylePropType = GenericStyleProp<NamedStyle>
